function loadChatWidgetWhenIdle() {
  const loadChatWidget = () => import("./chat-widget.js");

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(loadChatWidget, { timeout: 2500 });
    return;
  }

  window.addEventListener(
    "load",
    () => {
      window.setTimeout(loadChatWidget, 1200);
    },
    { once: true }
  );
}

loadChatWidgetWhenIdle();
